import { ExperimentName, ExperimentCookieName, ExperimentValue, type CoreExperiment, type ExperimentCookieNameUnion } from '@core/types'

export default defineNuxtRouteMiddleware(() => {
    const { experiments } = useCoreConfig()
    const { signupBundleExperiments } = usePromotionConfig()
    const { isLoggedIn, data: user } = useUserInfo()

    const cleanupInactiveExperiments = () => {
        const possibleExperiments = Object.values(ExperimentCookieName)
        const activeExperiments = experiments?.length
            ? experiments?.reduce((acc: ExperimentCookieNameUnion[], experiment: CoreExperiment) => {
                    acc.push(experiment.cookieName)

                    return acc
                }, [])
            : []

        possibleExperiments.forEach((cookieName) => {
            const isActiveExperiment = activeExperiments?.includes(cookieName)

            // Don't remove active experiments
            if (isActiveExperiment) return

            const experimentCookie = useCookie(cookieName)

            if (experimentCookie.value) {
                experimentCookie.value = null
            }
        })
    }

    if (import.meta.client) {
        cleanupInactiveExperiments()
    }

    if (!experiments?.length) return

    // Set cookie for each active experiment
    experiments.forEach((experiment: CoreExperiment) => {
        // Prevent setting cookie for empty required experiments
        if (!experiment?.versions?.[ExperimentValue.A] || !experiment?.versions?.[ExperimentValue.B]) return

        // Prevent setting cookie for experiments that needs authentication
        if (experiment?.needsAuthentication && !isLoggedIn.value) return

        // Prevent assigning userId experiments without a user identity
        const effectiveId = user.value?.id
        if (experiment.assignmentMethod === 'userId' && !effectiveId) return

        if (
            experiment.name === ExperimentName.BUNDLES
            && (!signupBundleExperiments?.a || !signupBundleExperiments?.b)
        ) return

        // Handle userId-based assignment before calling useExperiment
        if (experiment.assignmentMethod === 'userId' && effectiveId) {
            const experimentCookie = useCookie<ExperimentValue>(experiment.cookieName)
            if (!experimentCookie.value) {
                const groupSize = experiment.groupSize ?? 1
                experimentCookie.value = Math.floor(Number(effectiveId) / groupSize) % 2 === 0
                    ? ExperimentValue.A
                    : ExperimentValue.B
            }
        }

        useExperiment({
            cookieName: experiment.cookieName,
            experimentName: experiment.name,
            allowWrite: true
        })
    })
})
